import React, { useRef, useEffect, useState } from 'react';
import { resolveObjectFit } from '../../../utils/imageFit';
import videojs from 'video.js';

import 'video.js/dist/video-js.css';

const VideoJS = (props) => {
    const videoNode = useRef(null);
    const [player, setPlayer] = useState(null);

    useEffect(() => {
        if (videoNode.current) {
            const _player = videojs(videoNode.current, props);
            if (_player.readyState() < 1) {
                // wait for loadedmetdata event
                // _player.one("loadedmetadata", onLoadedMetadata);
            }
            else {
                // metadata already loaded
                var t = setInterval(function () {
                    if (_player.readyState() > 0) {
                        var duration = _player.duration();
                        if (duration != "Infinity") {
                        }
                        clearInterval(t);
                    }
                }, 500);

                setPlayer(_player);
                return () => {
                    if (player !== null) {
                        player.dispose();
                    }
                };
            }
        }
    }, [])

    return (
        <div data-vjs-player className="w-full h-full" style={{ width: '100%', height: '100%' }}>
            <video ref={videoNode} className="video-js" style={{ width: '100%', height: '100%', objectFit: resolveObjectFit(props.imageFit, !props.fill) }}></video>
        </div>
    );


}

export default VideoJS;